import { Fragment } from 'react';

import { Card } from '~src/components/display';
import { useLocalization } from '~src/hooks';
import { Offer } from '~src/types';
import { formatCurrency } from '~src/utilities/format';
import { divideOfferExpenses } from '~src/utilities/offer';

import { expensesSection, gridHeading } from './InstallerExpenseInformation.module.css';

type ProductInformationProps = {
  offer?: Pick<Offer, 'expenses'>;
};

export const InstallerExpenseInformation = ({ offer }: ProductInformationProps) => {
  const translate = useLocalization();

  const { expenses } = offer ?? {};

  const { physical, nonPhysical, installation } = divideOfferExpenses(expenses);

  return (
    <>
      {!!physical?.length && (
        <Card title={translate.EXTRA_PARTS}>
          <div className={expensesSection}>
            <span className={gridHeading}>{translate.QUANTITY}</span>
            <span className={gridHeading}>{translate.PRICE}</span>
            <span className={gridHeading}>{translate.PRODUCT}</span>
            {physical?.map(value => (
              <Fragment key={value.title}>
                <span>{value.quantity}</span>
                <span>-</span>
                <span>{value.title}</span>
              </Fragment>
            ))}
          </div>
        </Card>
      )}

      {!!nonPhysical?.length && (
        <Card title={translate.ADDED_EXPENSES}>
          <div className={expensesSection}>
            <span className={gridHeading}>{translate.QUANTITY}</span>
            <span className={gridHeading}>{translate.PRICE}</span>
            <span className={gridHeading}>{translate.PRODUCT}</span>
            {nonPhysical?.map(value =>
              value.buyPrice > 0 ? (
                <Fragment key={value.title}>
                  <span>{value.quantity}</span>
                  <span>{formatCurrency(value.buyPrice)}</span>
                  <span>{value.title}</span>
                </Fragment>
              ) : null
            )}
          </div>
        </Card>
      )}

      {!!installation?.length && (
        <Card title={translate.INSTALLATION}>
          <div className={expensesSection}>
            <span className={gridHeading}>{translate.QUANTITY}</span>
            <span className={gridHeading}>{translate.PRICE}</span>
            <span className={gridHeading}>{translate.PRODUCT}</span>
            {installation?.map(value => (
              <Fragment key={value.title}>
                <span>{value.quantity}</span>
                <span>-</span>
                <span>{value.title}</span>
              </Fragment>
            ))}
          </div>
        </Card>
      )}
    </>
  );
};
